/* istanbul ignore file */
export const getEventSource = (url: string, options?: EventSourceInit) => new EventSource(url, options);
